import { type Permission } from "app/mutations/__generated__/UpdateRoleAssignmentMutation.graphql";

export const EDIT_PERMISSION: Permission = "EDIT";
export const EDIT_ACL_PERMISSION: Permission = "EDIT_ACL";
export const VIEW_PERMISSION: Permission = "VIEW";
export const VIEW_ACL_PERMISSION: Permission = "VIEW_ACL";
export const REMOVE_PERMISSION: Permission = "REMOVE";
export const DEPLOY_PERMISSION: Permission = "DEPLOY_POLICIES";

type HasPermissionParams = readonly Permission[] | undefined;

function hasPermission(
  permissions: HasPermissionParams,
  allowed: Permission,
): boolean {
  if (!permissions || !Array.isArray(permissions)) {
    return false;
  }
  return permissions.some((permission) => allowed === permission);
}

/**
 * Check if entity has view permissions
 * @param userPermissions - Permissions array from entity
 * @returns true if entity has view permissions
 */
export function hasViewPermission(
  userPermissions: HasPermissionParams,
): boolean {
  return hasPermission(userPermissions, VIEW_PERMISSION);
}

/**
 * Check if entity has deploy-policies permissions
 * @param userPermissions - Permissions array from entity
 * @returns true if entity has deploy-policies permissions
 */
export function hasDeployPoliciesPermission(
  userPermissions: HasPermissionParams,
): boolean {
  return hasPermission(userPermissions, DEPLOY_PERMISSION);
}

/** Returns the different permissions from the userPermissions query response on an entity */
export function getUserPermissions(permissions: HasPermissionParams) {
  const canEdit = hasPermission(permissions, EDIT_PERMISSION);
  const canEditAcl = hasPermission(permissions, EDIT_ACL_PERMISSION);
  const canRemove = hasPermission(permissions, REMOVE_PERMISSION);
  const canDeploy = hasPermission(permissions, DEPLOY_PERMISSION);
  const canView = hasViewPermission(permissions);
  const canViewAcl = hasPermission(permissions, VIEW_ACL_PERMISSION);

  return {
    canView,
    canViewAcl,
    canEdit,
    canEditAcl,
    canRemove,
    canDeploy,
  };
}
